import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FolderTreeEntryModule } from '../../core-ui/FolderTreeEntry/FolderTreeEntry.module';
import { ModalModule } from '../../core-ui/Modal/Modal.module';
import { FolderSelectModalComponent } from './FolderSelectModal.component';
import { FolderSelectModalButtonComponent } from './FolderSelectModalButton.component';

export const FolderSelectModuleExports = [FolderSelectModalButtonComponent];

@NgModule({
    imports: [CommonModule, FormsModule, ModalModule, FolderTreeEntryModule],
    declarations: [FolderSelectModalComponent, ...FolderSelectModuleExports],
    exports: [...FolderSelectModuleExports],
    providers: []
})
export class FolderSelectModule {}
